export const convertHourToMs = (hour) => {
    return hour * 60 * 60 * 1000;

}